import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  InputLabel,
  MenuItem,
  Select,
  FormControl,
} from "@mui/material";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import axiosInstance from "Axiosinstance";
import Loader from "components/Loader";

const columns = [
  {
    dataField: "status",
    text: "Status",
    headerStyle: () => {
      return { width: "120px" };
    },
  },
  {
    dataField: "company",
    text: "Company Name",
  },
  {
    dataField: "count",
    text: "Count",
    headerStyle: () => {
      return { width: "120px" };
    },
  },
];

function Index() {
  const [companyList, setCompanyList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Fetch company names on mount
    const fetchCompanies = async () => {
      try {
        setLoading(true);
        const res = await axiosInstance.get("/api/getcompanynames");
        if (res.data && res.data.companyNames) {
          setCompanyList(res.data.companyNames);
          setLoading(false);
        }
      } catch (err) {
        setCompanyList([]);
        setLoading(false);
      }
    };
    fetchCompanies();
  }, []);

  const handleCompanyChange = (event) => {
    setSelectedCompany(event.target.value);
  };

  const handleSearch = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.post("/api/companywiseactivation", {
        companyname: selectedCompany,
      });
      if (res.data && Array.isArray(res.data.data)) {
        setTableData(res.data.data);
      } else {
        setTableData([]);
      }
    } catch (err) {
      setTableData([]);
    }
    setLoading(false);
  };

  return (
    <div className="page-content">
      {
        loading ? <Loader/> : <>
          <Box
        component="form"
        sx={{
          "& .MuiTextField-root": { m: 1, width: "25ch" },
        }}
        noValidate
        autoComplete="off"
      >
        <div
          style={{
            marginBottom: "2rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h1>Companywise Activation</h1>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "2rem",
          }}
        >
          <FormControl sx={{ minWidth: 220 }}>
            <InputLabel id="company-select-label">Select Company</InputLabel>
            <Select
              labelId="company-select-label"
              id="company-select"
              value={selectedCompany}
              label="Select Company"
              onChange={handleCompanyChange}
            >
              <MenuItem value="">
                <em>All</em>
              </MenuItem>
              {companyList.map((company) => (
                <MenuItem key={company} value={company}>
                  {company}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            onClick={handleSearch}
            style={{ marginLeft: "1rem", height: "56px" }}
            variant="contained"
            disabled={!selectedCompany || loading}
          >
            {loading ? "Searching..." : "Search"}
          </Button>
        </div>
        <div
          style={{ backgroundColor: "white", marginTop: "2rem" }}
          className="table-responsive"
        >
          <BootstrapTable
            keyField="id"
            data={tableData}
            columns={columns}
            pagination={paginationFactory()}
          />
        </div>
      </Box>
        </>
      }
    
    </div>
  );
}

export default Index;
